module.exports = __webpack_public_path__ + "8b45daa9f3e8e58f1f6f58904d10fe06.svg";